import { createGTMEvent } from '../../core/ecommerceMapper';
import { normalizeSegment } from '../../core/normalizers';
import { createDocumentGAEvent } from '../documents/documents';
import type { BillPaymentEventInput, InvoiceDocumentType, InvoiceDownloadEventInput } from './types';

const INVOICE_DOCUMENTS: Record<InvoiceDocumentType, string> = {
    INVOICE: 'Sąskaita',
    INVOICE_CREDIT: 'Kreditinė sąskaita',
    INVOICE_FORFEIT: 'Netesybų sąskaita',
    INVOICE_MOB: 'Mobiliojo ryšio paslaugų ataskaita',
    INVOICE_MOB_DETAILED: 'Mobiliojo ryšio paslaugų išklotinė',
    INVOICE_CUSTOMER: 'Kliento mokesčių ataskaita',
    INVOICE_FIX: 'Fiksuotojo ryšio paslaugų ataskaita',
    INVOICE_FIX_DETAILED_TV: 'Televizijos paslaugų išklotinė',
    INVOICE_FIX_DETAILED_PHONE: 'Fiksuotojo telefono paslaugų išklotinė',
    INVOICE_OTHER: 'Kitų mokesčių sąskaita',
    INVOICE_INST: 'Įmokų ataskaita',
    INVOICE_INST1: 'Atidėtų mokėjimų ataskaita',
};

export const createInvoiceDownloadGAEvent = ({ data }: InvoiceDownloadEventInput) => {
    const { documentType, fileType, segment, serviceGroup } = data;

    return createDocumentGAEvent({
        source: 'documents',
        event: 'file_download',
        data: {
            documentName: INVOICE_DOCUMENTS[documentType],
            serviceGroup,
            fileType: fileType?.toLowerCase(),
            segment: normalizeSegment(segment),
        },
    });
};

export const createBillPaymentGAEvent = ({ data }: BillPaymentEventInput) => {
    const { segment, bank, validationStatus } = data;

    return createGTMEvent('bill_payment', {
        segment: normalizeSegment(segment),
        bank,
        validation_status: validationStatus === 'SUCCEEDED' ? 'Success' : 'Failed',
    });
};
